import { LoginFormData } from '@/types'
import md5 from 'js-md5'
import request from '../request'

/**
 * 登录
 * @param username 用户名
 * @param password 密码
 */
export const apiPostLoginIn = (data: LoginFormData) =>
  request({
    url: '/xty-admin/admin-api/login/v1/submit',
    method: 'POST',
    headers: {
      Authorization: `Basic ${window.btoa(`${data.username}:${md5(data.password)}`)}`,
    },
  })
/**
 * 登出
 */
export const apiPostLoginOut = () =>
  request({
    url: '/xty-admin/admin-api/login/v1/logout',
    method: 'POST',
  })
